import { c as _c } from "react/compiler-runtime";
/** biome-ignore-all lint/suspicious/noArrayIndexKey: copied from cc-shopping-client */
import { css } from '@repo/pandacss/css';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
import { Typography } from '@repo/ui/Typography';
import { StructuredContentRenderer } from '@/shared/ui/structured-content/StructuredContentRenderer';
import { conBulletClass, proBulletClass, proConsListItemBase } from './utils';
const styles = {
  proConsListWrapper: css({
    flex: '[1]'
  }),
  proConsPlainList: css({
    pt: '0',
    pb: '3',
    pl: '0'
  }),
  proConsPlainListItem: css(proConsListItemBase),
  proConsListItemText: css({
    lineHeight: '[1.5rem]',
    '& span': {
      fontSize: {
        base: '[15px]',
        md: '1rem'
      }
    }
  })
} as const;
type ProsOrCons = 'pros' | 'cons';
type ProConsListProps = {
  items: string[];
  type: ProsOrCons;
};
function ProConsBullet(t0) {
  const $ = _c(6);
  const {
    type
  } = t0;
  const bulletClass = type === "pros" ? proBulletClass : conBulletClass;
  const glyph = type === "pros" ? "bullet-plus" : "bullet-minus";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      boxSize: "[10px]"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== glyph) {
    t2 = <MaskIcon glyph={glyph} css={t1} />;
    $[1] = glyph;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== bulletClass || $[4] !== t2) {
    t3 = <span className={bulletClass}>{t2}</span>;
    $[3] = bulletClass;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export const ProConsList = t0 => {
  const $ = _c(12);
  const {
    items,
    type
  } = t0;
  const isProsList = type === "pros";
  const t1 = isProsList ? "Pros" : "Cons";
  let t2;
  if ($[0] !== t1) {
    t2 = <Typography variant="text.bold">{t1}</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items || $[3] !== type) {
    let t4;
    if ($[5] !== type) {
      t4 = (item, index) => <li key={`${type.slice(0, 2)}-${index}`} className={styles.proConsPlainListItem}><ProConsBullet type={type} /><Typography variant="text" className={styles.proConsListItemText}><StructuredContentRenderer doc={item} /></Typography></li>;
      $[5] = type;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = items.map(t4);
    $[2] = items;
    $[3] = type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <ul className={styles.proConsPlainList}>{t3}</ul>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={styles.proConsListWrapper}>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};